import { render, staticRenderFns } from "./AddCredentialsOnboarding.vue?vue&type=template&id=6d94769e&scoped=true&"
import script from "./AddCredentialsOnboarding.vue?vue&type=script&lang=js&"
export * from "./AddCredentialsOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./AddCredentialsOnboarding.vue?vue&type=style&index=0&id=6d94769e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d94769e",
  null
  
)

export default component.exports